export default __webpack_public_path__ + "static/media/42.e966a445.png";